import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import moment from '../../../lib/moment.js'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import ReactList from 'react-list'
import { leave_history_report_table_header } from '../constants'
import arrow_down from '../../../static/images/arrow-down.svg'
import arrow_up from '../../../static/images/arrow-up.svg'
import { FONTS, COLORS } from '../../../constants'

export default class LeaveHistoryTable extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'history')) !== JSON.stringify(prevState.history)) {
      let list
      switch (prevState.sort_column) {
        case 0: {
          list = orderBy(get(nextProps, 'history'), 'start_date', 'desc')
          break
        }
        case 1: {
          list = orderBy(get(nextProps, 'history'), 'end_date', 'desc')
          break
        }
        case 2: {
          list = orderBy(get(nextProps, 'history'), 'days', 'desc')
          break
        }
        case 3: {
          list = orderBy(get(nextProps, 'history'), 'leave_type_name', 'desc')
          break
        }
        case 4: {
          list = orderBy(get(nextProps, 'history'), 'emp_code', 'desc')
          break
        }
        case 5: {
          list = orderBy(get(nextProps, 'history'), 'emp_name', 'desc')
          break
        }
        case 6: {
          list = orderBy(get(nextProps, 'history'), 'emp_company', 'desc')
          break
        }
        case 7: {
          list = orderBy(get(nextProps, 'history'), 'emp_lob', 'desc')
          break
        }
        default: {
          list = orderBy(get(nextProps, 'history'), (item) => {
            const order = {
              'PENDING': 1,
              'PENDING_HR': 2,
              'APPROVED': 3,
              'CANCEL': 4,
              'REJECTED': 5,
            }
            return order[item.status]
          }, 'desc')
        }
      }
      set(tempState, 'history', get(nextProps, 'history'))
      set(tempState, 'items', [...list])
    }
    return tempState
  }

  state={
    sort_order: true,
    sort_column: 0,
    history: [],
    items: [],
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(get(nextProps, 'history')) === JSON.stringify(get(this.props, 'history'))
    && JSON.stringify(get(nextState, 'items')) === JSON.stringify(get(this.state, 'items'))
    && nextState.sort_column === this.state.sort_column
    && nextState.sort_order === this.state.sort_order) return false
    return true
  }

  selectColor(status) {
    if (status === 'PENDING' || status === 'PENDING_HR') return '#FFD27C'
    else if (status === 'APPROVED') return '#333333'
    else if (status === 'REJECTED') return '#D9534F'
    return '#CCCCCC'
  }

  handleClickSort(column) {
    let { sort_order } = { ...this.state }
    const { history } = this.state

    if (column === this.state.sort_column) {
      sort_order = !this.state.sort_order
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      sort_order = false
      this.setState({
        sort_order: false,
        sort_column: column,
      })
    }
    sort_order = sort_order ? 'asc' : 'desc'
    switch (column) {
      case 0: {
        const newItems = orderBy(history, 'start_date', sort_order)
        return this.setState({ items: newItems })
      }
      case 1: {
        const newItems = orderBy(history, 'end_date', sort_order)
        return this.setState({ items: newItems })
      }
      case 2: {
        const newItems = orderBy(history, 'days', sort_order)
        return this.setState({ items: newItems })
      }
      case 3: {
        const newItems = orderBy(history, 'leave_type_name', sort_order)
        return this.setState({ items: newItems })
      }
      case 4: {
        const newItems = orderBy(history, 'emp_code', sort_order)
        return this.setState({ items: newItems })
      }
      case 5: {
        const newItems = orderBy(history, 'emp_name', sort_order)
        return this.setState({ items: newItems })
      }
      case 6: {
        const newItems = orderBy(history, 'emp_company', sort_order)
        return this.setState({ items: newItems })
      }
      case 7: {
        const newItems = orderBy(history, 'emp_lob', sort_order)
        return this.setState({ items: newItems })
      }
      case 8: {
        const newItems = orderBy(history, (item) => {
          const order = {
            'PENDING': 1,
            'PENDING_HR': 2,
            'APPROVED': 3,
            'CANCEL': 4,
            'REJECTED': 5,
          }
          return order[item.status]
        }, sort_order)
        return this.setState({ items: newItems })
      }
      default: return history
    }
  }

  renderItem = (index, key) => {
    const data = this.state.items[index]
    return (
      <tr
        key={ key }
        style={ { hover: '#E5E5E5' } }
        onClick={ () => this.props.handleClickRow(data) }
      >
        <td style={ { color: this.selectColor(get(data, 'status')) } }>
          <Circle status={ data.status } /> { get(data, 'status') }
        </td>
        <td>{ moment(get(data, 'start_date')).format('DD/MM/YYYY') }</td>
        <td>{ moment(get(data, 'end_date')).format('DD/MM/YYYY') }</td>
        <td>{ get(data, 'days') }</td>
        <td>{ get(data, 'leave_type_name') }</td>
        <td>{ get(data, 'emp_code') }</td>
        <td>{ get(data, 'emp_name') }</td>
        <td>{ get(data, 'emp_company') }</td>
        <td>{ get(data, 'emp_lob') }</td>
      </tr>
    )
  }

  render() {
    const { sort_order, sort_column, items } = this.state
    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <NewTable bordered hover>
          <Header>
            <tr>
              {
                leave_history_report_table_header.map((h) =>
                  (<HeadTable key={ h.value } onClick={ () => this.handleClickSort(h.value) } >
                    { h.label }
                    { h.value === sort_column && (
                      sort_order && h.value === sort_column ?
                        <Icon src={ arrow_up } alt="logo" />
                        :
                        <Icon src={ arrow_down } alt="logo" />
                    )
                    }</HeadTable>)
                )}
            </tr>
          </Header>
          <BodyTable>
            <ReactList
              itemRenderer={ this.renderItem }
              length={ items.length }
            />
          </BodyTable>
        </NewTable>
      </Wrapper>
    )
  }
}

LeaveHistoryTable.propTypes = {
  handleClickRow: PropTypes.func,
}
LeaveHistoryTable.defaultProps = {
  handleClickRow: () => {},
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const NewTable = styled(Table)`
  background: white;
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  }
`
const BodyTable = styled.tbody`
  width: 100% ;
  display: block ;
  max-height: calc(100vh - 210px);
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`
const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
`
const Circle = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${props => {
    const status = props.status
    if (status === 'PENDING' || status === 'PENDING_HR') {
      return '#FFD27C'
    } else if (status === 'APPROVED') {
      return '#333333'
    } else if (status === 'REJECTED') {
      return '#D9534F'
    }
    return '#CCCCCC'
  }};
`



// WEBPACK FOOTER //
// ./src/components/report/table/leave-history.js